// Keep only an explicitly chosen upgrade's input in this browser tab.
// The URL is never included in analytics or the signup/Stripe redirect URL.
const KEY = 'instanttranscriber_pending_url_import_v1';
const TTL = 2 * 60 * 60 * 1000;
function validUrl(value) {
  if (typeof value !== 'string' || value.length > 8192) return false;
  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol) && !url.username && !url.password && Boolean(url.hostname);
  } catch { return false; }
}
export function clearPendingUrlImport() {
  try { sessionStorage.removeItem(KEY); } catch {}
}
export function rememberPendingUrlImport(url, user, { resumeAfterUpgrade = false } = {}) {
  if (!user?.id || !validUrl(url)) return false;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ url: url.trim(), owner: user.id,
      guest: user.is_anonymous === true, resumeAfterUpgrade: resumeAfterUpgrade === true,
      expires: Date.now() + TTL }));
    return true;
  } catch { return false; }
}
export function pendingUrlImport(user) {
  if (!user?.id) return null;
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (!saved) return null;
    const sameAccount = saved.owner === user.id;
    const guestUpgraded = saved.guest === true && user.is_anonymous !== true;
    if (!validUrl(saved.url) || !Number.isFinite(saved.expires) || saved.expires <= Date.now()
        || saved.expires > Date.now() + TTL || (!sameAccount && !guestUpgraded)) {
      clearPendingUrlImport(); return null;
    }
    if (!sameAccount && guestUpgraded) {
      // Bind the one intended signup handover once; another later login cannot recover its URL.
      saved.owner = user.id;
      saved.guest = false;
      sessionStorage.setItem(KEY, JSON.stringify(saved));
    }
    return { url: saved.url, expires: saved.expires, resumeAfterUpgrade: saved.resumeAfterUpgrade === true };
  } catch { clearPendingUrlImport(); return null; }
}

export function claimPendingUrlImport(user) {
  const saved = pendingUrlImport(user);
  if (!saved?.resumeAfterUpgrade || user?.is_anonymous) return null;
  try {
    const stored = JSON.parse(sessionStorage.getItem(KEY));
    stored.resumeAfterUpgrade = false;
    sessionStorage.setItem(KEY, JSON.stringify(stored));
    return saved;
  } catch { return null; }
}
